// extracted by mini-css-extract-plugin
export default {"formContainer":"loginForm_formContainer__8VJJ6","checkbox":"loginForm_checkbox__H+44e"};